module.exports = __webpack_public_path__ + "img/defaultProductIco.41bc40f8.png";